import axios from "axios";
import * as Icons from "heroicons-react";
import React, { useState } from "react";
import { Modal, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { supplierProducts } from "../../../features/supplierSlice";
import { signInUser } from "../../Utility/Auth";
import { notify } from "../../Utility/Notify";
import SupplierProductImporter from "../CsvImporter/SupplierProductImporter";
import LoadingModal from "./LoadingModal";

const SupplierProductModal = ({
  handleClose,
  setPData,
  show,
  setShow,
}) => {
  const [csvData, setCsvData] = useState([]);
  const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";
  const dispatch = useDispatch();
  const supplierData = useSelector((state) => state.supplierReducer);

  const [loader, setLoader] = useState(false);
  const handleLoaderClose = () => setLoader(false);

  const importToCart = async () => {
    if (!csvData || csvData.length === 0) {
      notify("Please select a CSV file first!", "error");
      return;
    }

    setLoader(true);
    try {
      const auth = signInUser();
      let currentList = Array.isArray(supplierData?.products)
        ? [...supplierData.products]
        : [];
      let addedCount = 0;

      for (const product of csvData) {
        const article_code = (
          product?.article_code ||
          product?.code ||
          product?.Code ||
          product?.Article_code ||
          ""
        )
          .toString()
          .trim();

        const name = (
          product?.name ||
          product?.Name ||
          product?.product_name ||
          ""
        )
          .toString()
          .trim();

        const ean = (
          product?.ean ||
          product?.EAN ||
          product?.barcode ||
          ""
        )
          .toString()
          .trim();

        const unit = (
          product?.unit ||
          product?.Unit ||
          "EA"
        )
          .toString()
          .trim();

        if (!article_code && !name) {
          continue;
        }

        const isDuplicate = currentList.some(
          (pro) =>
            (article_code &&
              (pro?.article_code?.toString().toLowerCase() ===
                article_code.toLowerCase() ||
                pro?.code?.toString().toLowerCase() ===
                  article_code.toLowerCase())) ||
            (ean && pro?.ean?.toString().toLowerCase() === ean.toLowerCase())
        );

        if (isDuplicate) {
          continue;
        }

        let newProduct = null;

        if (article_code) {
          try {
            const res = await axios.get(
              `${BASE_URL}product/pro-details/${encodeURIComponent(article_code)}`
            );
            if (res?.data && res.data._id) {
              const apiData = res.data;
              newProduct = {
                id: apiData._id,
                article_code: apiData.article_code || article_code,
                ean: apiData.ean || ean,
                name: apiData.name || name || "Product",
                unit: apiData.unit || unit || "EA",
                aamarId: auth?.aamarId,
                warehouse: auth?.warehouse,
                order: currentList.length + 1,
              };
            }
          } catch (apiErr) {
            console.log("Could not fetch product from API:", apiErr);
          }
        }

        if (!newProduct) {
          newProduct = {
            id:
              product.id ||
              product._id ||
              article_code ||
              `pro_${Date.now()}_${Math.random().toString(36).substring(2, 7)}`,
            article_code: article_code,
            ean: ean,
            name: name || article_code || "Product",
            unit: unit || "EA",
            aamarId: auth?.aamarId,
            warehouse: auth?.warehouse,
            order: currentList.length + 1,
          };
        }

        currentList.push(newProduct);
        addedCount++;
      }

      dispatch(supplierProducts(currentList));
      if (typeof setPData === "function") {
        setPData(currentList);
      }

      if (addedCount > 0) {
        notify(`Successfully imported ${addedCount} product(s)!`, "success");
      } else {
        notify("No new products to import (may already exist in list)", "info");
      }

      setShow(false);
    } catch (err) {
      console.error("Error importing products:", err);
      notify("Failed to import products", "error");
    } finally {
      setLoader(false);
    }
  };

  return (
    <div>
      <LoadingModal
        title="Importing Products..."
        onShow={loader}
        handleClose={handleLoaderClose}
      ></LoadingModal>
      <Modal
        backdrop="static"
        keyboard={false}
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Import Supplier Products</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SupplierProductImporter
            setCsvData={setCsvData}
            handleImportButton={importToCart}
            title="Product"
          ></SupplierProductImporter>
          <div className="row">
            <div className="col-12">
              <Table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>EAN</th>
                    <th>Code</th>
                    <th>Name</th>
                  </tr>
                </thead>
                <tbody>
                  {csvData?.length > 0 &&
                    csvData.map((pro, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{pro.ean || pro.EAN || ""}</td>
                        <td>{pro.article_code || pro.code || pro.Code || ""}</td>
                        <td>{pro.name || pro.Name || ""}</td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SupplierProductModal;
